// cSpell:ignore Silae
import type { ReactNode } from "react";

const TAG_REGEX = /<(b|i|m|pc)>([\s\S]*?)<\/\1>/g;

const MUTED_CLS = "text-zinc-500 dark:text-zinc-400";

export function RichFormattedText({ text }: { text: string }) {
  const parts: ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;

  const pushMuted = (chunk: string) => {
    if (!chunk) return;
    const lines = chunk.split("\n");
    lines.forEach((line, i) => {
      if (i > 0) parts.push(<br key={key++} />);
      if (line)
        parts.push(
          <span key={key++} className={MUTED_CLS}>
            {line}
          </span>,
        );
    });
  };

  for (const match of text.matchAll(TAG_REGEX)) {
    const start = match.index ?? 0;
    if (start > lastIndex) {
      pushMuted(text.slice(lastIndex, start));
    }
    const [, tag, content] = match;
    if (tag === "b") {
      parts.push(
        <strong
          key={key++}
          className="font-semibold text-zinc-900 dark:text-zinc-50"
        >
          {content}
        </strong>,
      );
    } else if (tag === "i") {
      parts.push(
        <em key={key++} className="italic text-zinc-900 dark:text-zinc-50">
          {content}
        </em>,
      );
    } else if (tag === "pc") {
      parts.push(
        <span
          key={key++}
          className="inline-flex items-center gap-1 rounded border border-violet-300/70 dark:border-violet-700/60 bg-violet-50 dark:bg-violet-950/40 px-1.5 py-0.5 font-mono text-[10px] text-violet-800 dark:text-violet-200"
        >
          {content}
        </span>,
      );
    } else {
      parts.push(
        <span key={key++} className={MUTED_CLS}>
          {content}
        </span>,
      );
    }
    lastIndex = start + match[0].length;
  }

  if (lastIndex < text.length) {
    pushMuted(text.slice(lastIndex));
  }

  return <>{parts}</>;
}
